import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { selectStyles } from "../utils/selectStyles";
const Modal = ({
  attribute,
  attributeValues = [],
  selectedValues = { attributeValue: [] },
  onSave,
  handleInputChange,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const updatedOptions =
      selectedValues?.attributeValue?.map((child) => {
        const matchingOption = attributeValues?.find((item) => item.id === child.id);
        return {
          value: child.id,
          label: matchingOption?.name || child.id,
        };
      }) || [];
    if (JSON.stringify(updatedOptions) !== JSON.stringify(selectedOptions)) {
      setSelectedOptions(updatedOptions);
    }
  }, [selectedValues?.attributeValue, attributeValues]);

  const handleChangeAttr = (selected, updatedDates) => {
    const safeSelected = Array.isArray(selected) ? selected : [];
    setSelectedOptions(safeSelected);

    const children = safeSelected.map((option) => ({
      id: option.value,
      value: updatedDates ? updatedDates[option.value] : null,
    }));

    const attrId = attributeValues?.[0]?.attr_id;
    if (!attrId) return;

    const payload = {
      attribute_id: attrId,
      attributeValue: children,
    };

    handleInputChange(attrId, payload);
  };

  const handleCreate = (inputValue) => {
    if (attribute === "Label" || attribute === "color") return;
    const newOption = { value: inputValue, label: inputValue };
    const updatedOptions = [...selectedOptions, newOption];
    setSelectedOptions(updatedOptions);
    handleChangeAttr(updatedOptions);
  };

  return (
    <CreatableSelect
      name="attributes"
      placeholder={`Select ${attribute}`}
      value={selectedOptions}
      onChange={(selected) => handleChangeAttr(selected)}
      onCreateOption={handleCreate}
      options={attributeValues?.map((item) => ({
        value: item.id,
        label: item.name,
      }))}
      isMulti
        styles={selectStyles}
    />
  );
};



export default Modal;





























